import { styled } from "@mui/material/styles";

const StyledIcon = styled("i", {
  shouldForwardProp: (prop) => prop !== "colorFunc",
})(({ theme, colorFunc }) => {
  return {
    color: colorFunc ? `${colorFunc(theme.palette)}` : "",
    fontWeight: 500,
  };
});

export default StyledIcon;
